import React from 'react';
import _ from 'lodash';
import { withApollo, compose } from 'react-apollo';

import emailTemplate from '../../../utils/emailTemplate';
import getTaskTitle from '../../../utils/getTaskTitle';
import { CreateOutgoingEmailMessage } from '../../../mutations/CreateOutgoingEmailMessage';
import TaskView from './TaskView';
import withClaimQuery from './withClaimQuery';

class SendLoaTask extends React.Component {
  state = {};

  componentDidUpdate(prevProps) {
    if (this.props.claim && !prevProps.claim) {
      this.setEmailContent();
    }
  }
  componentDidMount() {
    if (!this.props.claim) return;
    this.setEmailContent();
  }

  setEmailContent = () => {
    const { email } = emailTemplate(this.props.claim, 'sendLOA') || {};
    this.setState({ paxReplyEmail: email });
  };

  handleInputChange = (e, { value }) => this.setState({ paxReplyEmail: value });

  handleMessageSend = () => {
    const { client, task, claim, onTaskComplete } = this.props;
    const { paxReplyEmail } = this.state;
    const passengerEmail = _.get(
      claim,
      'passengerTicket.passengerEmail',
      ''
    );
    this.setState({ loading: true });
    client
      .mutate({
        mutation: CreateOutgoingEmailMessage,
        variables: {
          input: {
            taskId: task.id,
            emailMessage: {
              to: passengerEmail,
              subject: 'LOA',
              content: paxReplyEmail,
              senderType: 'pax',
              triggeringType: 'manual'
            }
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
        onTaskComplete();
      })
      .catch(() => this.setState({ loading: false }));
  };

  render = () => {
    const { claim, loading, task, onClaimClosed } = this.props;
    return (
      <TaskView
        claim={claim}
        task={task}
        taskTitle={getTaskTitle(task)}
        loading={loading || this.state.loading}
        onClaimClosed={onClaimClosed}
        onInputChange={this.handleInputChange}
        onMessageSend={this.handleMessageSend}
        paxReplyEmail={this.state.paxReplyEmail}
      />
    );
  };
}

const SendLoaWithData = compose(
  withApollo,
  withClaimQuery
)(SendLoaTask);

export default SendLoaWithData;



// WEBPACK FOOTER //
// ./src/component/tasks/SendLoaTask/index.js